import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import logo from "../assets/images/logo.png";
import ConsultationForm from "../pages/Consultation";
import Calculator from "../pages/Cost-Calculator";


const NAV_ITEMS = [
  {
    label: "Services",
    dropdown: [
      { label: "Architects & Construction", path: "/architects-construction" },
  { label: "3D Designs", path: "/3d-designs" },
  { label: "NABH Consultant", path: "/nabh-consultant" },
  {
    label: "MEP Services",
    submenu: [
      { label: "Plumbing And Electrical (LT & HT)", path: "/plumbing-electrical" },
      // { label: "Electrical (LT & HT)", path: "/plumbing-electrical" },
      { label: "Medical Gases", path: "/medical-gases" },
      { label: "IVF", path: "/ivf" },
      { label: "Fire & Safety", path: "/fire-safety" },
      { label: "HVAC", path: "/hvac" },
    ],
  },
  {
    label: "ELV Systems",
    submenu: [
      { label: "CCTV & Networking", path: "/cctv-networking" },
      { label: "Nurse Calling", path: "/nurse-calling" },
      { label: "Access Control", path: "/access-control" },
      { label: "EPBAX", path: "/epbax" },
    ],
  },
  { label: "Interior Services", path: "/interior-services" },
  { label: "Modular Operation Theatres", path: "/modular-operation-theatres" },
  { label: "Medical Furniture", path: "/medical-furniture" },
  { label: "Medical Equipment", path: "/medical-equipment" },
  { label: "Dialysis Setup", path: "/dialysis-setup" },
  { label: "ICU Setup", path: "/icu-setup" },
  { label: "Biomedical Services", path: "/biomedical-service" },
  { label: "Hospital Administration", path: "/hospital-administration" },
    ],
  },
  {
    label: "Design Ideas",
    dropdown: [
      { label: "OT Suite Designs",         path: "/ot-suite-designs"          },
      { label: "ICU Layout Designs",          path: "/icu-layout-designs"        },
      { label: "Patient Ward Designs",       path: "/patient-ward-designs"     },
      { label: "Reception Lobby Designs",            path: "/reception-lobby-designs"          },
      { label: "Diagnostic Room Designs",         path: "/diagnostic-room-designs"       },
      { label: "Pharmacy Designs", path: "/pharmacy-designs" },
      { label: "Nursing Station Designs", path: "/nursing-station-designs" },
      { label: "Isolation Room Designs", path: "/isolation-room-designs" },
      { label: "Paediatric Ward Designs", path: "/paediatric-ward-designs" },
      { label: "Oncology Unit Designs", path: "/oncology-unit-designs" },
      { label: "Maternity Suite Designs", path: "/maternity-suite-designs" },
      { label: "Lab & Pathology Designs", path: "/lab-pathology-designs" },
    ],
  },
  {
    label: "Cities",
    dropdown: [
      { label: "Bhuvanagiri", path: "/bhuvanagiri" },
      { label: "Hyderabad", path: "/hyderabad" },
      { label: "Indresham", path: "/indresham" },
      { label: "Jangaon", path: "/jangaon" },
      { label: "Khammam", path: "/khammam" },
      { label: "Mahabubnagar", path: "/mahabubnagar" },
      { label: "Narsapur", path: "/narsapur" },
      { label: "Rajahmundry", path: "/rajahmundry" },
      { label: "Sangareddy", path: "/sangareddy" },
      { label: "Vijayawada", path: "/vijayawada" },
    ],
  },
  { label: "Projects",      dropdown: [], route: "/projects"      },
  { label: "Store Locator", dropdown: [], route: "/store-locator" },
  {
    label: "More",
    dropdown: [
      { label: "About Us",         path: "/about"          },
      { label: "Careers",          path: "/careers"        },
      { label: "Contact Us",       path: "/contact-us"     },
      // { label: "Press",            path: "/press"          },
      { label: "Policies",         path: "/policies"       },
       { label: "Terms and conditions", href: "/terms-and-conditions" },
      // { label: "Refer a Hospital", path: "/refer-hospital" },
    ],
  },
];

const SECONDARY_NAV = [
  { label: "How it works",         route: "/how-it-works"     },
  { label: "Our Services",         route: "/our-services"     },
  { label: "Cost Calculators",     route: "/cost-calculator" },
  { label: "The Hospital Journey", route: "/hospital-journey" },
  // { label: "Own a Franchise",      route: "/franchise"        },
  // { label: "NABH Compliance",      route: "/nabh-compliance", isNew: true },
];

function DesktopGroupItem({ d, navigate, setActiveDropdown }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="tevah-dropdown-group">
      <button className="tevah-dropdown-group-btn" onClick={() => setOpen((v) => !v)}>
        {d.label}
        <span className={`tevah-group-arrow${open ? " open" : ""}`}>▾</span>
      </button>
      {open && (
        <div className="tevah-inline-submenu">
          {d.submenu.map((sub) => (
            <button
              key={sub.label}
              className="tevah-submenu-item"
              onClick={() => {
                setActiveDropdown(null);
                navigate(sub.path);
              }}
            >
              {sub.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

function CollapseItem({
  item, mobileExpanded, setMobileExpanded, mobileGroupExpanded,
  toggleMobileGroup, handleMobileNavClick, location, navigate, setMobileOpen,
}) {
  const isCurrentPage = item.route && location.pathname === item.route;
  return (
    <div className="tevah-mobile-item">
      <div
        className={`tevah-mobile-row${isCurrentPage ? " current-page" : ""}`}
        onClick={() => handleMobileNavClick(item)}
      >
        <span>{item.label}</span>
        {item.dropdown.length > 0 && (
          <span style={{ fontSize: 18, color: "#A7ACBD" }}>
            {mobileExpanded === item.label ? "−" : "+"}
          </span>
        )}
        {isCurrentPage && (
          <span style={{ fontSize: 10, background: "#343F86", color: "#fff", padding: "2px 8px", borderRadius: 4, fontWeight: 700, marginLeft: "auto" }}>
            YOU ARE HERE
          </span>
        )}
      </div>
      {mobileExpanded === item.label && item.dropdown.length > 0 && (
        <div className="tevah-mobile-sub">
          {item.dropdown.map((d) =>
            typeof d === "object" && d.path ? (
              <div key={d.label} className="tevah-mobile-plain-item"
                onClick={() => { setMobileOpen(false); navigate(d.path); }}>
                {d.label}
              </div>
            ) : typeof d === "object" && d.submenu ? (
              <div key={d.label}>
                <div className="tevah-mobile-group-header" onClick={() => toggleMobileGroup(d.label)}>
                  <span>{d.label}</span>
                  <span style={{ fontSize: 16, color: "#A7ACBD" }}>{mobileGroupExpanded[d.label] ? "−" : "+"}</span>
                </div>
                {mobileGroupExpanded[d.label] && (
                  <div>
                    {d.submenu.map((sub) => (
                      <div key={sub.label} className="tevah-mobile-sub-item"
                        onClick={() => { setMobileOpen(false); navigate(sub.path); }}>
                        {sub.label}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            ) : typeof d === "object" && d.label ? (
              <div key={d.label} className="tevah-mobile-plain-item"
                onClick={() => { setMobileOpen(false); navigate(`/${d.label.toLowerCase().replace(/ &/g, "").replace(/\s+/g, "-")}`); }}>
                {d.label}
              </div>
            ) : (
              <div key={d} className="tevah-mobile-plain-item">{d}</div>
            )
          )}
        </div>
      )}
    </div>
  );
}

export default function Navbar() {
  const [activeDropdown,      setActiveDropdown]      = useState(null);
  const [scrolled,            setScrolled]            = useState(false);
  const [mobileOpen,          setMobileOpen]          = useState(false);
  const [mobileExpanded,      setMobileExpanded]      = useState(null);
  const [mobileGroupExpanded, setMobileGroupExpanded] = useState({});
  const [showConsultation,    setShowConsultation]    = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    if (showConsultation) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => { document.body.style.overflow = ""; };
  }, [showConsultation]);

  useEffect(() => {
    if (mobileOpen) {
      document.body.style.overflow = "hidden";
    } else if (!showConsultation) {
      document.body.style.overflow = "";
    }
  }, [mobileOpen, showConsultation]);

  const toggleMobileGroup = (key) =>
    setMobileGroupExpanded((prev) => ({ ...prev, [key]: !prev[key] }));

  const handleNavClick = (item) => {
    if (item.dropdown.length === 0 && item.route) navigate(item.route);
  };

  const handleMobileNavClick = (item) => {
    if (item.dropdown.length === 0 && item.route) {
      setMobileOpen(false);
      navigate(item.route);
    } else {
      setMobileExpanded(mobileExpanded === item.label ? null : item.label);
    }
  };

  const openConsultation = () => {
    setMobileOpen(false);
    setShowConsultation(true);
  };

  return (
    <>
      <style>{`
        * { font-family: 'Inter', 'Montserrat', sans-serif; }

        .tevah-nav {
          position: fixed; top: 0; left: 0; right: 0; z-index: 1000;
          background: ${scrolled ? "rgba(255,255,255,0.98)" : "#fff"};
          box-shadow: ${scrolled ? "0 2px 20px rgba(0,0,0,0.10)" : "0 1px 0 #E1E3EE"};
          transition: all 0.3s ease;
        }
        .tevah-primary-bar {
          max-width: 1280px; margin: 0 auto; padding: 0 24px;
          display: flex; align-items: center; height: 64px; gap: 24px;
          justify-content: space-between;
        }
        .tevah-logo { display: flex; align-items: center; gap: 10px; text-decoration: none; flex-shrink: 0; }
        .tevah-logo-icon { width: 120px; height: 38px; display: flex; align-items: center; justify-content: center; }
        .tevah-logo-img { max-width: 120px; height: auto; }

        .tevah-nav-links { display: flex; align-items: center; gap: 2px; flex: 1; justify-content: center; list-style: none; margin: 0; padding: 0; }
        .tevah-nav-item { position: relative; }

        .tevah-nav-btn {
          background: none; border: none; cursor: pointer;
          padding: 8px 12px; border-radius: 7px;
          font-family: 'Inter', 'Montserrat', sans-serif; font-size: 13px;
          font-weight: 500; color: #262E63;
          display: flex; align-items: center; gap: 4px;
          transition: background 0.2s, color 0.2s; white-space: nowrap;
        }
        .tevah-nav-btn:hover, .tevah-nav-btn.active { background: #ECEEF6; color: #343F86; }
        .tevah-nav-btn.current-page { background: #343F86 !important; color: #fff !important; border-radius: 7px; }

        .tevah-caret { font-size: 9px; transition: transform 0.2s; display: inline-block; }
        .tevah-caret.open { transform: rotate(180deg); }

        .tevah-dropdown {
          position: absolute; top: 100%; left: 0; padding-top: 6px;
          min-width: 240px; background: transparent;
          z-index: 999;
        }
        .tevah-dropdown-inner {
          background: #fff; border-radius: 14px;
          box-shadow: 0 8px 40px rgba(0,0,0,0.13); border: 1px solid #ECEEF6;
          padding: 8px 0; animation: dropIn 0.2s ease;
          max-height: calc(100vh - 100px);
          overflow-y: auto;
        }
        @keyframes dropIn { from { opacity: 0; transform: translateY(-8px); } to { opacity: 1; transform: translateY(0); } }

        .tevah-dropdown-item {
          display: block; width: 100%; text-align: left; background: none; border: none;
          padding: 10px 20px; font-family: 'Inter', 'Montserrat', sans-serif;
          font-size: 13px; color: #3A4060; cursor: pointer; transition: background 0.15s; white-space: nowrap;
        }
        .tevah-dropdown-item:hover { background: #F6F7FC; color: #343F86; }

        .tevah-dropdown-group { position: relative; }
        .tevah-dropdown-group-btn {
          display: flex; width: 100%; align-items: center; justify-content: space-between; gap: 16px;
          text-align: left; background: none; border: none; padding: 10px 20px;
          font-family: 'Inter', 'Montserrat', sans-serif; font-size: 13px; font-weight: 600;
          color: #343F86; cursor: pointer; transition: background 0.15s; white-space: nowrap;
          border-top: 1px solid #ECEEF6;
        }
        .tevah-dropdown-group-btn:hover { background: #F6F7FC; }
        .tevah-group-arrow { font-size: 10px; color: #A7ACBD; transition: transform 0.2s; display: inline-block; }
        .tevah-group-arrow.open { transform: rotate(180deg); }

        .tevah-inline-submenu {
          background: #F6F7FC; border-top: 1px solid #ECEEF6; border-bottom: 1px solid #ECEEF6;
          animation: dropIn 0.15s ease;
          max-height: 240px;
          overflow-y: auto;
        }
        .tevah-dropdown-inner,
        .tevah-mobile-sub,
        .tevah-inline-submenu {
          scrollbar-width: none;        /* Firefox */
          -ms-overflow-style: none;     /* IE/Edge */
        }
        .tevah-dropdown-inner::-webkit-scrollbar,
        .tevah-mobile-sub::-webkit-scrollbar,
        .tevah-inline-submenu::-webkit-scrollbar {
          display: none;                /* Chrome/Safari */
        }
        .tevah-submenu-item {
          display: block; width: 100%; text-align: left; background: none; border: none;
          padding: 9px 20px 9px 32px;
          font-family: 'Inter', 'Montserrat', sans-serif;
          font-size: 12.5px; color: #5B6072; cursor: pointer; transition: background 0.15s; white-space: nowrap;
        }
        .tevah-submenu-item:hover { background: #ECEEF6; color: #343F86; }

        .tevah-nav-right { display: flex; align-items: center; gap: 14px; flex-shrink: 0; }
        .tevah-phone { display: flex; flex-direction: column; align-items: flex-end; line-height: 1.2;text-decoration: none; color: inherit; }
        .tevah-phone-label { font-size: 10px; color: #2F8A98; font-weight: 500; letter-spacing: 0.5px; text-transform: uppercase; }
        .tevah-phone-num { font-size: 14px; color: #343F86; font-weight: 600; letter-spacing: 0.3px; }
        .tevah-cta-btn {
          background: #343F86; color: #fff; border: none; border-radius: 9px; padding: 10px 20px;
          font-family: 'Inter', 'Montserrat', sans-serif; font-size: 13px; font-weight: 700;
          cursor: pointer; transition: all 0.2s; white-space: nowrap;
        }
        .tevah-cta-btn:hover { background: #262E63; transform: translateY(-1px); }
        .tevah-hamburger {
          display: none; background: none; border: none; cursor: pointer; padding: 6px;
          flex-direction: column; gap: 5px; align-items: center; justify-content: center;
          flex-shrink: 0;
        }
        .tevah-hamburger span { display: block; width: 22px; height: 2px; background: #343F86; border-radius: 2px; transition: all 0.2s; }

        .tevah-secondary-bar { border-top: 1px solid #ECEEF6; background: #F6F7FC; }
        .tevah-secondary-inner {
          max-width: 1280px; margin: 0 auto; padding: 0 24px;
          display: flex; align-items: center; height: 42px;
          overflow-x: auto;
        }
        .tevah-secondary-links { display: flex; align-items: center; gap: 2px; }
        .tevah-secondary-btn {
          background: none; border: none; cursor: pointer;
          font-family: 'Inter', 'Montserrat', sans-serif; font-size: 12.5px;
          color: #5B6072; font-weight: 500; padding: 4px 12px; white-space: nowrap;
          border-bottom: 2px solid transparent; transition: all 0.2s; border-radius: 0;
        }
        .tevah-secondary-btn:hover { color: #343F86; border-bottom-color: #343F86; }
        .tevah-secondary-btn.sec-active { color: #343F86; border-bottom-color: #343F86; font-weight: 700; }
        .tevah-new-tag {
          font-size: 9px; background: #343F86; color: #fff;
          padding: 2px 6px; border-radius: 3px; margin-left: 5px; font-weight: 700; letter-spacing: 0.5px;
        }

        .tevah-mobile-menu {
          display: none; position: fixed; top: 0; left: 0; right: 0; bottom: 0;
          background: #fff; z-index: 1100; flex-direction: column; overflow-y: auto;
        }
        .tevah-mobile-menu.open { display: flex; }
        .tevah-mobile-header {
          display: flex; align-items: center; justify-content: space-between;
          padding: 14px 20px; border-bottom: 1px solid #ECEEF6;
          flex-shrink: 0;
        }
        .tevah-mobile-close {
          background: #ECEEF6; border: none; cursor: pointer; font-size: 20px; color: #343F86;
          width: 36px; height: 36px; border-radius: 50%;
          display: flex; align-items: center; justify-content: center; flex-shrink: 0;
        }
        .tevah-mobile-close:hover { background: #E1E3EE; }
        .tevah-mobile-list { padding: 8px 0; flex: 1; }
        .tevah-mobile-item { border-bottom: 1px solid #ECEEF6; }
        .tevah-mobile-row {
          display: flex; align-items: center; justify-content: space-between;
          padding: 14px 20px; cursor: pointer;
          font-family: 'Inter', 'Montserrat', sans-serif; font-size: 14.5px; font-weight: 600; color: #343F86;
        }
        .tevah-mobile-row.current-page { background: #ECEEF6; border-left: 3px solid #343F86; }
        .tevah-mobile-sub {
          padding: 0 20px 10px 32px;
          display: flex; flex-direction: column; gap: 2px;
          max-height: 50vh;
          overflow-y: auto;
        }
        .tevah-mobile-group-header {
          display: flex; align-items: center; justify-content: space-between;
          padding: 10px 0 4px; cursor: pointer; font-size: 13px; font-weight: 700; color: #343F86;
          border-top: 1px solid #ECEEF6; margin-top: 4px;
        }
        .tevah-mobile-group-header:first-of-type { border-top: none; margin-top: 0; }
        .tevah-mobile-sub-item { padding: 9px 0 9px 12px; font-size: 13px; color: #5B6072; border-bottom: 1px solid #F6F7FC; cursor: pointer; }
        .tevah-mobile-sub-item:hover { color: #343F86; }
        .tevah-mobile-plain-item { padding: 9px 0; font-size: 13px; color: #5B6072; border-bottom: 1px solid #F6F7FC; cursor: pointer; }
        .tevah-mobile-plain-item:hover { color: #343F86; }
        .tevah-mobile-cta { padding: 16px 20px; border-top: 1px solid #ECEEF6; flex-shrink: 0; }
        .tevah-mobile-cta-btn {
          width: 100%; background: #343F86; color: #fff; border: none; border-radius: 10px;
          padding: 14px; font-family: 'Inter', 'Montserrat', sans-serif;
          font-size: 14px; font-weight: 700; cursor: pointer;
        }
        .tevah-mobile-call-btn {
          width: 100%; background: #fff; color: #343F86; border: 1.5px solid #E1E3EE; border-radius: 10px;
          padding: 12px; font-family: 'Inter', 'Montserrat', sans-serif;
          font-size: 13px; font-weight: 600; cursor: pointer;
          margin-top: 10px; text-decoration: none;
          display: flex; align-items: center; justify-content: center; gap: 6px;
        }

        /* Consultation Modal */
        .tevah-modal-overlay {
          position: fixed; inset: 0; z-index: 2000;
          background: rgba(0, 0, 0, 0.65);
          backdrop-filter: blur(5px);
          display: flex; align-items: center; justify-content: center;
          padding: 1rem;
          animation: fadeIn 0.2s ease;
        }
        @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
        .tevah-modal-inner {
          position: relative; width: 100%; max-width: 680px;
          max-height: 90vh; overflow-y: auto; border-radius: 18px;
          animation: slideUp 0.25s ease;
        }
        @keyframes slideUp { from { opacity: 0; transform: translateY(20px); } to { opacity: 1; transform: translateY(0); } }
        .tevah-modal-close {
          position: absolute; top: 14px; right: 16px; z-index: 10;
          background: #262E63; border: none; color: #fff;
          width: 32px; height: 32px; border-radius: 50%;
          font-size: 20px; cursor: pointer;
          display: flex; align-items: center; justify-content: center;
          line-height: 1; transition: background 0.15s;
        }
        .tevah-modal-close:hover { background: #3A4060; }

        /* ── TABLET / MOBILE (≤900px): switch to hamburger ── */
        @media (max-width: 900px) {
          .tevah-nav-links { display: none; }
          .tevah-secondary-bar { display: none; }
          .tevah-hamburger { display: flex; }
          .tevah-phone { display: none; }
          .tevah-primary-bar { padding: 0 16px; height: 60px; gap: 12px; }
          .tevah-logo-icon { width: 100px; height: 32px; }
          .tevah-logo-img { max-width: 100px; }
          .tevah-nav-right { gap: 10px; }
          .tevah-cta-btn { padding: 9px 16px; font-size: 12.5px; }
        }

        /* ── SMALL MOBILE (≤480px): tighten further ── */
        @media (max-width: 480px) {
          .tevah-primary-bar { padding: 0 12px; height: 56px; gap: 8px; }
          .tevah-logo-icon { width: 84px; height: 28px; }
          .tevah-logo-img { max-width: 84px; }
          .tevah-cta-btn { padding: 8px 12px; font-size: 12px; border-radius: 8px; }
          .tevah-hamburger { padding: 4px; }
          .tevah-hamburger span { width: 20px; }
          .tevah-mobile-header { padding: 12px 16px; }
          .tevah-mobile-row { padding: 13px 16px; font-size: 14px; }
          .tevah-mobile-sub { padding: 0 16px 10px 28px; }
          .tevah-mobile-cta { padding: 14px 16px; }
        }
      `}</style>

      <nav className="tevah-nav">
        <div className="tevah-primary-bar">
          <a href="/" className="tevah-logo">
            <div className="tevah-logo-icon">
              <img src={logo} alt="PR Hospital Designers Logo" className="tevah-logo-img" />
            </div>
          </a>

          <ul className="tevah-nav-links">
            {NAV_ITEMS.map((item) => {
              const isCurrentPage = item.route && location.pathname === item.route;
              const hasDropdown   = item.dropdown.length > 0;
              return (
                <li
                  key={item.label}
                  className="tevah-nav-item"
                  onMouseEnter={() => hasDropdown && setActiveDropdown(item.label)}
                  onMouseLeave={() => setActiveDropdown(null)}
                >
                  <button
                    className={[
                      "tevah-nav-btn",
                      activeDropdown === item.label ? "active" : "",
                      isCurrentPage ? "current-page" : "",
                    ].filter(Boolean).join(" ")}
                    onClick={() => handleNavClick(item)}
                  >
                    {item.label}
                    {hasDropdown && (
                      <span className={`tevah-caret${activeDropdown === item.label ? " open" : ""}`}>▾</span>
                    )}
                  </button>

                  {hasDropdown && activeDropdown === item.label && (
                    <div
                      className="tevah-dropdown"
                      onMouseEnter={() => setActiveDropdown(item.label)}
                      onMouseLeave={() => setActiveDropdown(null)}
                    >
                      <div className="tevah-dropdown-inner">
                        {item.dropdown.map((d) =>
                          typeof d === "object" && d.path ? (
                            <button key={d.label} className="tevah-dropdown-item"
                              onClick={() => { navigate(d.path); setActiveDropdown(null); }}>
                              {d.label}
                            </button>
                          ) : typeof d === "object" && d.submenu ? (
                            <DesktopGroupItem key={d.label} d={d} navigate={navigate} setActiveDropdown={setActiveDropdown} />
                          ) : typeof d === "object" && d.label ? (
                            <button key={d.label} className="tevah-dropdown-item"
                              onClick={() => { setActiveDropdown(null); navigate(`/${d.label.toLowerCase().replace(/ &/g, "").replace(/\s+/g, "-")}`); }}>
                              {d.label}
                            </button>
                          ) : (
                            <button key={d} className="tevah-dropdown-item"
                              onClick={() => { setActiveDropdown(null); navigate(`/${d.toLowerCase().replace(/ &/g, "").replace(/\s+/g, "-")}`); }}>
                              {d}
                            </button>
                          )
                        )}
                      </div>
                    </div>
                  )}
                </li>
              );
            })}
          </ul>

          <div className="tevah-nav-right">
            <a href="tel:+919993999840" className="tevah-phone">
  <span className="tevah-phone-label">Toll Free</span>
  <span className="tevah-phone-num">+91 99939 99840</span>
</a>
            <button className="tevah-cta-btn" onClick={openConsultation}>
              Free Consultation
            </button>
            <button className="tevah-hamburger" onClick={() => setMobileOpen(true)} aria-label="Open menu">
              <span /><span /><span />
            </button>
          </div>
        </div>

        <div className="tevah-secondary-bar">
          <div className="tevah-secondary-inner">
            <div className="tevah-secondary-links">
              {SECONDARY_NAV.map((item) => {
                const isActive = location.pathname === item.route;
                return (
                  <button
                    key={item.label}
                    className={`tevah-secondary-btn${isActive ? " sec-active" : ""}`}
                    onClick={() => navigate(item.route)}
                  >
                    {item.label}
                    {item.isNew && <span className="tevah-new-tag">NEW</span>}
                  </button>
                );
              })}
            </div>
          </div>
        </div>
      </nav>

      {/* Mobile Menu */}
      <div className={`tevah-mobile-menu${mobileOpen ? " open" : ""}`}>
        <div className="tevah-mobile-header">
          <a href="/" className="tevah-logo">
            <div className="tevah-logo-icon">
              <img src={logo} alt="PR Hospital Designers Logo" className="tevah-logo-img" />
            </div>
          </a>
          <button className="tevah-mobile-close" onClick={() => setMobileOpen(false)} aria-label="Close menu">✕</button>
        </div>

        <div className="tevah-mobile-list">
          {NAV_ITEMS.map((item) => (
            <CollapseItem
              key={item.label}
              item={item}
              mobileExpanded={mobileExpanded}
              setMobileExpanded={setMobileExpanded}
              mobileGroupExpanded={mobileGroupExpanded}
              toggleMobileGroup={toggleMobileGroup}
              handleMobileNavClick={handleMobileNavClick}
              location={location}
              navigate={navigate}
              setMobileOpen={setMobileOpen}
            />
          ))}
          <div style={{ borderTop: "1px solid #ECEEF6", marginTop: 8, padding: "12px 20px 4px" }}>
            <div style={{ fontSize: 10, fontWeight: 700, color: "#7FD0DA", letterSpacing: 1.5, textTransform: "uppercase", marginBottom: 10 }}>
              Quick Links
            </div>
            {SECONDARY_NAV.map((item) => (
              <div
                key={item.label}
                className="tevah-mobile-plain-item"
                onClick={() => { setMobileOpen(false); navigate(item.route); }}
                style={{ display: "flex", alignItems: "center", gap: 6 }}
              >
                {item.label}
                {item.isNew && (
                  <span style={{ fontSize: 9, background: "#343F86", color: "#fff", padding: "2px 6px", borderRadius: 3, fontWeight: 700 }}>
                    NEW
                  </span>
                )}
              </div>
            ))}
          </div>
        </div>

        <div className="tevah-mobile-cta">
          <button className="tevah-mobile-cta-btn" onClick={openConsultation}>
            Book Free Consultation
          </button>
          <a href="tel:+919993999840" className="tevah-mobile-call-btn">
            📞 +91 99939 99840
          </a>
        </div>
      </div>

      {/* Consultation Modal */}
      {showConsultation && (
        <div
          className="tevah-modal-overlay"
          onClick={(e) => { if (e.target === e.currentTarget) setShowConsultation(false); }}
        >
          <div className="tevah-modal-inner">
            <button
              className="tevah-modal-close"
              onClick={() => setShowConsultation(false)}
              aria-label="Close consultation form"
            >
              ×
            </button>
            <ConsultationForm />
          </div>
        </div>
      )}
    </>
  );
}